import {createAction} from '@reduxjs/toolkit'

export const setPages = createAction('pagination/setPages')
export const setPage = createAction('pagination/setPage')
export const setInitial = createAction('pagination/setInitial')
